import {AbstractJavascriptFunctionCallVO} from "./AbstractJavascriptFunctionCallVO";
import {JavascriptFunctionName} from "../JavascriptFunctionName";

export class JavascriptCallSetCashHashVO implements AbstractJavascriptFunctionCallVO {
    public functionName = JavascriptFunctionName.SET_CASH_HASH;
    public parameters = [];

    constructor(setCashHash: string) {
        this.parameters.push(setCashHash)
    }
}

